import get from 'lodash.get';

const getButtonPresetTemplate = (state) =>
  get(state, 'ws.template.meta.customization.buttonPresetTemplate', '');

export default getButtonPresetTemplate;
